import React from "react";
import classNames from "classnames";

import styles from "./FramedImage.module.scss";

import { FramePaths } from "./frames";

export type FramePathList = keyof typeof FramePaths;

interface FramedImageProps {
  src?: string;
  className?: string;
  overlay?: boolean;
  pathName?: FramePathList;
}

const FramedImage: React.FC<FramedImageProps> = ({
  src,
  className,
  overlay,
  pathName = "RoundOne",
}) => {
  const { width, height, path } = FramePaths[pathName];

  return (
    <div
      className={classNames(
        styles.frame,
        { [styles.overlay]: overlay },
        className
      )}
      style={
        {
          "--clip-path-name": `url(#${pathName})`,
        } as React.CSSProperties
      }
    >
      <svg
        viewBox={`0 0 ${width} ${height}`}
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        strokeMiterlimit="10"
        preserveAspectRatio="none"
      >
        <defs>
          <clipPath
            id={pathName}
            clipPathUnits="objectBoundingBox"
            transform={`scale(${1 / width}, ${1 / height})`}
          >
            <path d={path} />
          </clipPath>
        </defs>
        <path
          d={path}
          fill="none"
          stroke="currentColor"
          vectorEffect="non-scaling-stroke"
        />
      </svg>
      <div className={styles.hover} />
      {src && <img src={src} alt="" />}
    </div>
  );
};

export { FramedImage };
